<main class="inquiry-page">

    <section *ngIf="formSection" class="inquiry-form" [ngClass]="['inquiry-form--step-' + currentStep, 'inquiry-form--' + direction]" aria-labelledby="inquiry-title">
  
      <header class="inquiry-form__header">
        <div class="inquiry-form__header-text">
          <p class="inquiry-form__eyebrow">Inquiry Form</p>
          <h1 class="inquiry-form__title" id="inquiry-title">Talk to Us</h1>
        </div>
        <p class="inquiry-form__counter" aria-live="polite">
          <span class="inquiry-form__counter-current">{{ stepCounter }}</span> / <span class="inquiry-form__counter-total">03</span>
          <span class="inquiry-form__sr-only">Step {{ currentStep }} of 3</span>
        </p>
      </header>
  
      <div class="inquiry-form__progress" role="progressbar" aria-label="Form progress" aria-valuemin="1" aria-valuemax="3" [attr.aria-valuenow]="currentStep">
        <span class="inquiry-form__progress-bar"></span>
      </div>
  
      <form class="inquiry-form__form" [formGroup]="contactForm" (ngSubmit)="sendContactUsForm()" novalidate>
  
        <!-- Honeypot -->
        <input type="text" formControlName="website" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute;left:-9999px;opacity:0;height:0;width:0;">
  
        <!-- ============ STEP 1: User type ============ -->
        <fieldset class="inquiry-form__step" [class.inquiry-form__step--active]="currentStep === 1" data-step="1">
          <legend class="inquiry-form__legend">
            Who are you exploring DocuMark for?
            <span class="inquiry-form__required" aria-hidden="true">*</span>
          </legend>
  
          <div class="inquiry-form__options" [class.inquiry-form__options--error]="isInvalid('userType')" role="radiogroup" aria-required="true" aria-describedby="user-type-error">
  
            <label class="inquiry-form__option" for="user-type-k12">
              <input class="inquiry-form__option-input" type="radio" id="user-type-k12" formControlName="userType" value="K-12 school" required aria-required="true">
              <span class="inquiry-form__option-radio" aria-hidden="true"></span>
              <span class="inquiry-form__option-text">My K-12 school</span>
            </label>
  
            <label class="inquiry-form__option" for="user-type-university">
              <input class="inquiry-form__option-input" type="radio" id="user-type-university" formControlName="userType" value="university / institution" required aria-required="true">
              <span class="inquiry-form__option-radio" aria-hidden="true"></span>
              <span class="inquiry-form__option-text">My university/institution</span>
            </label>
  
            <label class="inquiry-form__option" for="user-type-individual">
              <input class="inquiry-form__option-input" type="radio" id="user-type-individual" formControlName="userType" value="Myself" required aria-required="true">
              <span class="inquiry-form__option-radio" aria-hidden="true"></span>
              <span class="inquiry-form__option-text">Myself (as an individual professor, teacher, university employee)</span>
            </label>
  
            <label class="inquiry-form__option" for="user-type-exploring">
              <input class="inquiry-form__option-input" type="radio" id="user-type-exploring" formControlName="userType" value="Just exploring" required aria-required="true">
              <span class="inquiry-form__option-radio" aria-hidden="true"></span>
              <span class="inquiry-form__option-text">Just exploring</span>
            </label>
  
          </div>
          <p class="inquiry-form__error" id="user-type-error" role="alert">Please select one option to continue.</p>
  
          <div class="inquiry-form__actions">
            <button class="inquiry-form__button inquiry-form__button--primary inquiry-form__button--full" type="button" data-action="next" (click)="nextStep()">
              <span>Next</span>
              <svg class="inquiry-form__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </fieldset>
  
        <!-- ============ STEP 2: Contact information ============ -->
        <fieldset class="inquiry-form__step" [class.inquiry-form__step--active]="currentStep === 2" data-step="2">
          <legend class="inquiry-form__sr-only">Contact information</legend>
  
          <div class="inquiry-form__grid">
  
            <div class="inquiry-form__field mb-20" [class.inquiry-form__field--error]="isInvalid('firstName')">
              <label class="inquiry-form__label" for="full-name">
                First Name <span class="inquiry-form__required" aria-hidden="true">*</span>
              </label>
              <input class="inquiry-form__input" type="text" id="full-name" formControlName="firstName" placeholder="Your name" autocomplete="name" required aria-required="true" aria-describedby="full-name-error">
              <p class="inquiry-form__error" id="full-name-error" role="alert">Enter your first name.</p>
            </div>
  
            <div class="inquiry-form__field mb-20" [class.inquiry-form__field--error]="isInvalid('lastName')">
              <label class="inquiry-form__label" for="full-name">
                Last Name <span class="inquiry-form__required" aria-hidden="true">*</span>
              </label>
              <input class="inquiry-form__input" type="text" id="full-name" formControlName="lastName" placeholder="Your name" autocomplete="name" required aria-required="true" aria-describedby="full-name-error">
              <p class="inquiry-form__error" id="full-name-error" role="alert">Enter your last name.</p>
            </div>
          </div>
  
          <div class="inquiry-form__grid w-100">
  
            <div class="inquiry-form__field" [class.inquiry-form__field--error]="isInvalid('contactFormEmail')">
              <label class="inquiry-form__label" for="country">
                Email <span class="inquiry-form__required" aria-hidden="true">*</span>
              </label>
              <input class="inquiry-form__input" type="text" id="email" formControlName="contactFormEmail" placeholder="Email" autocomplete="email" required aria-required="true" aria-describedby="email">
              <p class="inquiry-form__error" id="country-error" role="alert">Enter a valid email.</p>
            </div>
  
            <div class="inquiry-form__field" [class.inquiry-form__field--error]="isInvalid('DesignationTypes')">
              <label class="inquiry-form__label" for="designation">Designation <span class="inquiry-form__required" aria-hidden="true">*</span></label>
              <input class="inquiry-form__input" type="text" id="designation" formControlName="DesignationTypes" placeholder="Your role" autocomplete="desgination" required aria-required="true" aria-describedby="designation-error">
              <p class="inquiry-form__error" id="designation-error" role="alert">Enter your designation</p>
            </div>
  
            <div class="inquiry-form__field w-100" [class.inquiry-form__field--error]="isInvalid('organization')">
              <label class="inquiry-form__label" for="organization">
                Organization <span class="inquiry-form__required" aria-hidden="true">*</span>
              </label>
              <input class="inquiry-form__input" type="text" id="organization" formControlName="organization" placeholder="Institution name" autocomplete="organization" required aria-required="true" aria-describedby="organization-error">
              <p class="inquiry-form__error" id="organization-error" role="alert">Enter your organization.</p>
            </div>
  
          </div>
  
          <div class="inquiry-form__actions inquiry-form__actions--split">
            <button class="inquiry-form__button inquiry-form__button--secondary" type="button" data-action="back" (click)="previousStep()">
              <svg class="inquiry-form__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M13 8H3M7 4L3 8l4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Back</span>
            </button>
            <button class="inquiry-form__button inquiry-form__button--primary" type="button" data-action="next" (click)="nextStep()">
              <span>Next</span>
              <svg class="inquiry-form__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </fieldset>
  
        <!-- ============ STEP 3: Requirement details ============ -->
        <fieldset class="inquiry-form__step" [class.inquiry-form__step--active]="currentStep === 3" data-step="3">
          <legend class="inquiry-form__sr-only">Requirement details</legend>
  
          <div class="inquiry-form__field" [class.inquiry-form__field--error]="isInvalid('message')">
            <label class="inquiry-form__label" for="message">
              How can we help? <span class="inquiry-form__required" aria-hidden="true">*</span>
            </label>
            <textarea class="inquiry-form__textarea" id="message" formControlName="message" rows="5" placeholder="e.g. We are looking to integrate DocuMark in our university's LMS" required aria-required="true" aria-describedby="message-error"></textarea>
            <p class="inquiry-form__error" id="message-error" role="alert">Tell us how we can help.</p>
          </div>
  
          <div class="inquiry-form__field" [class.inquiry-form__field--error]="isInvalid('timeline')">
            <label class="inquiry-form__label" for="timeline">
              When are you planning to integrate DocuMark? <span class="inquiry-form__required" aria-hidden="true">*</span>
            </label>
            <div class="inquiry-form__select-wrap">
              <select class="inquiry-form__select" id="timeline" formControlName="timeline" required aria-required="true" aria-describedby="timeline-error">
                <option value="" disabled>Select a timeline</option>
                <option value="within-1-month">Within 1 month</option>
                <option value="1-3-months">1-3 months</option>
                <option value="3-6-months">3-6 months</option>
                <option value="just-exploring">Just exploring</option>
              </select>
              <svg class="inquiry-form__select-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="inquiry-form__error" id="timeline-error" role="alert">Select a timeline.</p>
          </div>
  
          <div class="inquiry-form__actions inquiry-form__actions--split">
            <button class="inquiry-form__button inquiry-form__button--secondary" type="button" data-action="back" (click)="previousStep()">
              <svg class="inquiry-form__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M13 8H3M7 4L3 8l4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Back</span>
            </button>
            <button class="inquiry-form__button inquiry-form__button--primary submit-btn" type="submit" [disabled]="isSubmitting">
                <div id="loading"></div>
                <span>Submit</span>
              <svg class="inquiry-form__button-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        </fieldset>
  
      </form>
    </section>
  
    <!-- Thank-you -->
    <section *ngIf="thankSection" class="thank_section contact_us_form" role="status">
        <div class="SVGwrapper">
            <svg width="82px" height="82px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#16A34A" stroke="#16A34A"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>checkmark-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-102.000000, -1141.000000)" fill="#16A34A"> <path d="M124.393,1151.43 C124.393,1151.43 117.335,1163.73 117.213,1163.84 C116.81,1164.22 116.177,1164.2 115.8,1163.8 L111.228,1159.58 C110.85,1159.18 110.871,1158.54 111.274,1158.17 C111.677,1157.79 112.31,1157.81 112.688,1158.21 L116.266,1161.51 L122.661,1150.43 C122.937,1149.96 123.548,1149.79 124.027,1150.07 C124.505,1150.34 124.669,1150.96 124.393,1151.43 L124.393,1151.43 Z M118,1141 C109.164,1141 102,1148.16 102,1157 C102,1165.84 109.164,1173 118,1173 C126.836,1173 134,1165.84 134,1157 C134,1148.16 126.836,1141 118,1141 L118,1141 Z" id="checkmark-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>
        </div>
        <div class="form-group mt-4">
            <h2>Thank You!</h2>
            <p>We will contact you soon.</p>
        </div>
    </section>
  
  </main>